import { Box } from "@mui/system";
import { COLORS } from "../../ui/Theme";
import { Delete } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Loading from "../loader/Loading";

const FavoriteContainer = ({
  children,
  handleSelectedFavorite,
  handleDeleteFavorite,
  favorite,
}) => {
  return (
    <Box
      onClick={() => handleSelectedFavorite(favorite)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#FAFAFA",
        border: `1px solid ${COLORS.SOFTGRAY}`,
        borderRadius: "12px",
        width: "100%",
        padding: "12px 26px",
        cursor: "pointer",
        transition: "all 0.1s ease",
        ":hover": {
          borderColor: COLORS.BLUE,
          color: COLORS.BLUE,
          backgroundColor: COLORS.SOFTBLUE,
        },
      }}
    >
      {children}
      <IconButton
        onClick={(e) => handleDeleteFavorite(favorite.id, e)}
        sx={{ color: COLORS.RED }}
      >
        <Delete sx={{ width: "24px" }} />
      </IconButton>
    </Box>
  );
};

export default FavoriteContainer;
